import React, { useState, useEffect, useRef } from 'react'
import HeadingArea from '../../general/HeadingArea'
import { AiOutlineSearch } from 'react-icons/ai';
import { FaPrint } from 'react-icons/fa';

const EmpAtdReport = ({ setLoading, userData }) => {
  const [selectedRole, setSelectedRole] = useState("");

    const [report, setReport] = useState([]);
    const [academicYears, setAcademicYears] = useState([]);
    const [selectedAY, setSelectedAY] = useState('');
    const [selectedMonth, setSelectedMonth] = useState('');
    const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const fetchAcademicYears = async () => {
        setLoading(true);
        try {
            const response = await fetch('https://api.kcian.in/get-academic-years');
            if (response.ok) {
                const data = await response.json();
                const sortedData = data.sort((a, b) => b.id - a.id);
                setAcademicYears(sortedData);
            } else {
                console.error('Failed to fetch academic years');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    // Initial fetches for classes and academic years
    useEffect(() => {   
        fetchAcademicYears();
    }, []);

    const handleSearch = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {

            // Build query params
            const params = new URLSearchParams();
            params.append('ay', selectedAY);
            params.append('month', selectedMonth);
params.append('role', userData.role == 'SupAdmin' ? selectedRole : userData.role);

            const url = `https://api.kcian.in/get-staffatd-report?${params.toString()}`;

            const response = await fetch(url);

            if (response.ok) {
                const resData = await response.json();

                let data = resData;
if (userData.role != 'SupAdmin') {
  data = resData.filter(item => item.user_id == userData.user_id);
}

                setReport(data);
            } else {
                console.error('Failed to fetch students atd report');
            }
        } catch (error) {
            console.error('Error fetching students atd report:', error);
        } finally {
            setLoading(false);
        }
    };



    const printRef = useRef(); // ref for the report section


const handlePrint = () => {
  if (!printRef.current) return;

  const printContents = printRef.current.innerHTML;

  const printWindow = window.open('', '', 'height=600,width=800');
  printWindow.document.write('<html><head><title>Student Attendance Report</title>');

  printWindow.document.write('<style>');
  printWindow.document.write(`
    html, body {
      margin: 0;
      padding: 0;
    }
    table {
      border-collapse: collapse;
    }
    th, td {
      border: 1px solid #000;
      padding: 5px;
      text-align: center;
      white-space: nowrap;
    }
    th {
      background-color: #f0f0f0;
    }
    .profile-btn2 {
      display: none;
    }
    .profile-heading {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 15px;
    }
       @page {
      margin: 2px;
    }
  `);
  printWindow.document.write('</style>');

  printWindow.document.write('</head><body>');
  printWindow.document.write(printContents);
  printWindow.document.write('</body></html>');

  printWindow.document.close();
  printWindow.focus();

  printWindow.print();
  printWindow.close();
};

  
const getAllDatesInMonth = (monthName, year) => {
  const monthIndex = months.indexOf(monthName);
  const dates = [];
  const totalDays = new Date(year, monthIndex + 1, 0).getDate(); // Last day of month

  for (let day = 1; day <= totalDays; day++) {
    const dayStr = day.toString().padStart(2, '0');
    const monthStr = (monthIndex + 1).toString().padStart(2, '0');
    dates.push(`${year}-${monthStr}-${dayStr}`);
  }

  return dates;
};

const allDates = selectedMonth && selectedAY
  ? getAllDatesInMonth(selectedMonth, selectedAY)
  : [];

  console.log(allDates);

    return (
        <>
            <section className='py-4'>
                <div className='px-4'>
                    <HeadingArea message1='Attendance' message2='Employees Attendance Report' />

                    <form onSubmit={handleSearch} className='profile-card'>
                        <span className="profile-heading">Select Criteria</span>

                        <div className='row mt-3'>

                            <div className="col-lg-4 col-md-6 col-6 mb-4">
                                <div className='profile-input-area'>
                                    <label className="profile-badge">Select AY*</label>
                                    <select
                                        className="profile-input"
                                        value={selectedAY}
                                        onChange={(e) => setSelectedAY(e.target.value)}
                                        required
                                    >
                                        <option value="">-- Select Academic Year --</option>
                                        {academicYears.map((ay) => (
                                            <option key={ay.year} value={ay.year}>
                                                {ay.year} --- {ay.title}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>


                            <div className="col-lg-4 col-md-6 col-6 mb-4">
                                <div className='profile-input-area'>
                                    <label className="profile-badge">Select Month*</label>
                                    <select
                                        className="profile-input"
                                        value={selectedMonth}
                                        onChange={(e) => setSelectedMonth(e.target.value)}
                                        required
                                    >
                                        <option value="">-- Select Month --</option>
                                        {months.map((month, idx) => (
                                            <option key={idx} value={month}>
                                                {month}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

{userData.role == 'SupAdmin' &&
              <div className="col-lg-4 col-md-6 col-6 mb-4">
                <div className='profile-input-area'>
                  <label className="profile-badge">Select Role*</label>
                  <select
                    className="profile-input"
                    value={selectedRole}
                    onChange={(e) => setSelectedRole(e.target.value)}
                    // required
                  >
                    <option value="">-- Select Role --</option>
                    <option value="Teacher">Teacher</option>
                    <option value="Librarian">Librarian</option>
                    <option value="Accountant">Accountant</option>
                    <option value="Driver">Driver</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              </div>
}



                        </div>
                        {/* flex ends */}


                        <div className='text-end'>
                            <button type='submit' className='profile-btn2'>
                                <AiOutlineSearch /> Search
                            </button>
                        </div>
                    </form>
                    {/* form ends */}


                    <div className='profile-card mt-3' ref={printRef}>

                        
                        <span className="profile-heading">Employee Attendance Report - {selectedRole} {selectedMonth} {selectedAY}</span>

<div className='text-end'>
                            <button type='submit' className='profile-btn2' onClick={handlePrint}>
                                <FaPrint /> Print
                            </button></div>

<p className='text-muted'>Present: P Absent: A Leave: L Holiday: H Half Day: F</p>
            <div className='table-responsive mb-3'>
<table className='w-100'>
<thead className='account-thead'>
  <tr>
    <th>Reg No</th>
    <th>Name</th>
    <th>P</th>
    <th>A</th>
    <th>L</th>
    <th>H</th>
    <th>F</th>
    <th>%</th>
{allDates.map(date => (
  <th key={date} className='text-nowrap'>{new Date(date).getDate()}</th>
))}
    <th>Note</th>
  </tr>
</thead>

<tbody>
  {report.length === 0 ? (
    <tr className='text-center account-tr'>
      <td colSpan="100%">No Student Data found</td>
    </tr>
  ) : (() => {
    const grouped = {};

    // Group by student_id
    report.forEach(rpt => {
      const id = rpt.uId;
      if (!grouped[id]) {
        grouped[id] = {
          staff_name: rpt.staff_name,
          user_id: rpt.user_id,
          dates: {},
          present: 0,
          absent: 0,
          leave: 0,
          halfDay: 0,
          holiday: 0,
          note: rpt.note,
        };
      }

      const mark = rpt.mark;

if (mark === 'Present') grouped[id].present += 1;
else if (mark === 'Absent') grouped[id].absent += 1;
else if (mark === 'Leave') grouped[id].leave += 1;
else if (mark === 'Half Day') grouped[id].halfDay += 1;
else if (mark === 'Holiday') grouped[id].holiday += 1;

const markShortCodes = {
  'Present': 'P',
  'Absent': 'A',
  'Leave': 'L',
  'Holiday': 'H',
  'Half Day': 'F'
};

grouped[id].dates[rpt.date] = markShortCodes[mark] || '';

    });

    return Object.entries(grouped).map(([id, data], index) => (
      <tr key={index} className='account-tr'>
        <td className='border'>{data.user_id}</td>
        <td className='border'>{data.staff_name}</td>
        <td className='border'>{data.present}</td>
        <td className='border'>{data.absent}</td>
        <td className='border'>{data.leave}</td>
        <td className='border'>{data.holiday}</td>
        <td className='border'>{data.halfDay}</td>
<td className='border'>
  {(
    ((data.present + data.holiday + 0.5 * data.halfDay) / 
     (data.present + data.holiday + data.absent + data.leave + data.halfDay)
    ) * 100
  ).toFixed(1)}%
</td>
{allDates.map(date => (
  <td className='border' key={date}>{data.dates[date] || ''}</td>
))}
        <td className='border'>{data.note}</td>
      </tr>
    ));
  })()}
</tbody>



</table>
</div>


                    </div>
{/* report ends */}


                </div>
            </section>
        </>
    )
}

export default EmpAtdReport
